import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import BackgroundPaper from "../../components/atomic/BackgroundPaper";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import TrxImage from "../../assets/trx.png";
import { LivePricesTable } from "../../components/compound/LivePricesTable/LivePricesTable";
import { useEffect } from "react";
import CryptoCards from "../../components/cryptocards/cryptocards";

export default function Markets() {
  const [t] = useTranslation();
  return (
    <Box sx={{ pb: 10 }} bgcolor={"background.default"}>
      <Paper
        elevation={0}
        sx={{
          pt: 8,
          pb: 15,
          bgcolor: "background.default",
          borderRadius: 0,
          mx: 0,
        }}
      >
        <Typography variant={"h4"} sx={{ textAlign: "center" }}>
          {t("crypto_live_prices")}
        </Typography>
      </Paper>
      <Paper sx={{ p: 3, mt: -12, mx: { xs: 1, sm: 2, md: 10 } }}>
        <Box>
          <CryptoCards />
        </Box>
      </Paper>
      <Paper sx={{ mx: { xs: 1, sm: 2, md: 10 }, mt: 5, p: 2 }}>
        <LivePricesTable />
      </Paper>
    </Box>
  );
}
